<ng-container *ngIf="submenuItems.length > 1">
    <submenu-bar [submenuItems]="submenuItems"></submenu-bar>
</ng-container>

<router-outlet></router-outlet>
